import React from "react";
import MetaTitle from "~/components/Shared/MetaTitle";
import { isMobile, isBrowser, isTablet } from 'react-device-detect';
import DesktopPresentationModal from "./Desktop";
import MobilePresentationModal from "./Mobile";

export type TPresentationModalProps = {
  open: boolean;
  onToggle: () => void;
}

const Index = ({ open, onToggle }: TPresentationModalProps) => {

  return <React.Fragment>
    <MetaTitle>Presentation</MetaTitle>
    {/* Tablet View */}
    {isTablet && <DesktopPresentationModal open={open} onToggle={onToggle} />}
    {/* Browser and not Tablet View */}
    {isBrowser && !isTablet && <DesktopPresentationModal open={open} onToggle={onToggle} />}
    {/* Mobile and not Tablet View */}
    {isMobile && !isTablet && <MobilePresentationModal open={open} onToggle={onToggle} />}
  </React.Fragment>
}

export default Index;
